angular.module('mobilezuz').controller('DeliveryFeeInfoDialog', ['$scope', 'mDesign', 'text',
    function ($scope, mDesign, text) {
        $scope.dialog = mDesign;
        $scope.text = text;

        $scope.hide = function () {
            mDesign.cancel();
        };
    }
]);